export default "__VITE_ASSET__c8c6f16d__"